import axios, { AxiosInstance } from "axios";
import { Config } from "../../config";

const config = new Config();

const createApiInstance = (baseURL: string): AxiosInstance => {
  return axios.create({ baseURL });
};

const AgentApi = createApiInstance(config.settings.AgentApiUrl);
const HubApi = createApiInstance(config.settings.HubApiUrl);
const AppApi = createApiInstance(config.settings.AppApiUrl);
const AccountsUrl = createApiInstance(config.settings.AccountsApiUrl);

const AppApiBearer = {
  headers: {Authorization: config.settings.AppBearer}
}

const HubApiBearer = {
  headers: { Authorization: config.settings.HubApiBearer },
};

const AccountsApiBearer = {
  headers: {Authorization: config.settings.AccountsApiBearer}
}

export const startAgentChat = async (payload: any, initiate: boolean = false, version: string = "") => {
  const res = await AgentApi.post(initiate ? (version === 'v1'? "agent_start/": "candidate/chatbot/initialize") : (version === 'v1'? "chat/": "candidate/chatbot/run"), payload);
  return res.data;
};

export const endAgentChat = async (payload: any, version: string = "") => {
  const res = await AgentApi.post((version === 'v1'? "agent_end/": "candidate/chatbot/end"), payload);
  return res.data;
};

export const submitConsent = async (payload: any, version: string = "") => {
  const res = await AgentApi.post(version === 'v1'? "consent/": "compliance/user_consent/", payload);
  return res.data;
};

export const getSessionInfoByAI = async (payload: any) => {
  const res = await AppApi.post(`v2/flow/HandleAgentReplacements`, payload, AppApiBearer);
  return res.data;
}

export const getSessionInfoByHub = async (uniqueId: any) => {
  const res = await HubApi.get(`v1/AIAutomation/${uniqueId}/fetch`, HubApiBearer);
  return res.data;
}

export const getUrlSettings = async (key: string, domainName: string) => {
  const res = await HubApi.get(`UrlSetting?key=${key}&domainName=${domainName}`, HubApiBearer);
  return res.data;
}

export const getBrandDetails = async (clientCode: string) => {
  const res = await AccountsUrl.get(`v1/aiagent/${clientCode}/configuration`, AccountsApiBearer);
  return res.data;
}